import React, { PureComponent } from "react";
import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import { Tooltip, CircularProgress } from "@material-ui/core";
import UploadIcon from 'mdi-react/FileUploadOutlineIcon';

import { _axiosCall } from "../../../../shared/helpers/apicalls";

const apiUrl = process.env.API_ROOT + "/buyerslist/imageupload";

class DropZoneField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired, // Top-level prop for name
    onChange: PropTypes.func.isRequired,
    customHeight: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
        })
      ),
    ]).isRequired,
    SnapShotDropZoneHeight: PropTypes.bool,
    SnapShotDropLoader: PropTypes.bool,
    defaultImage: PropTypes.string, // Prop for default image
    callback: PropTypes.func, // Prop for callback function
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
    }), // Input prop
  };

  static defaultProps = {
    customHeight: false,
    SnapShotDropZoneHeight: false,
    SnapShotDropLoader: false,
    defaultImage: "", // Default empty string for defaultImage
    callback: null, // Default null for callback
    input: {}, // Default empty object for input
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      files: this.initializeFiles(props), // Initialize with input.value or defaultImage
    };
    this.onDrop = this.onDrop.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value ||
      prevProps.defaultImage !== this.props.defaultImage
    ) {
      this.setState({
        files: this.initializeFiles(this.props),
      });
    }
  }

  initializeFiles(props) {
    const { value, defaultImage } = props;
    const imageUrl = value || defaultImage;
    return imageUrl ? [{ preview: imageUrl }] : [];
  }

  onDrop(files) {
    const { onChange, SnapShotDropLoader, callback } = this.props;

    const formData = new FormData();
    if (SnapShotDropLoader) {
      this.setState({ isLoading: true });
    }

    files.forEach((file) => {
      formData.append("file", file);
    });

    const photoData = {
      url: apiUrl,
      method: "post",
      query: formData,
    };

    _axiosCall(photoData)
      .then((res) => {
        const uploadedFiles = res.map((fl) => ({ preview: fl }));
        this.setState(
          {
            files: [...uploadedFiles],
          },
          () => {
            if (onChange) {
              onChange(this.state.files[0].preview);
            }
            if (callback) {
              callback(uploadedFiles[0].preview); // Execute callback with the first image URL
            }
          }
        );
      })
      .catch((error) => {
        console.error("onDrop error ", error);
      })
      .finally(() => {
        if (SnapShotDropLoader) {
          this.setState({ isLoading: false });
        }
      });
  }

  removeFile(index, e) {
    const { onChange, callback } = this.props;
    e.preventDefault();

    this.setState(
      {
        files: [],
      },
      () => {
        if (onChange) {
          onChange(""); // Reset the input value
        }
        if (callback) {
          callback(""); // Execute callback after image removal
        }
      }
    );
  }

  render() {
    const { customHeight, name, SnapShotDropZoneHeight, label } = this.props;
    const { isLoading, files } = this.state;

    return (
      <div>
      <p>{label}</p>
      <div
        className={`dropzone dropzone--single`} style={{width:180,height:100,border:"2px solid #000",borderRadius:4,background:"#FFF"}}>
        {isLoading ? (
          <div className="dropzone__input dropzone__loader" style={{width:"100%",height:"100%",justifyContent:"center",alignItems:"center"}}>
            <CircularProgress style={{ color: "#780F9E" }} />
          </div>
        ) : (
          <>
            <Dropzone
              accept="image/jpeg, image/png"
              multiple={false}
              onDrop={this.onDrop} // Bind onDrop to class method
            >
              {({ getRootProps, getInputProps }) => (
                <Tooltip
                  title={"Upload a JPEG or PNG photo"}
                >
                  <div {...getRootProps()} className="dropzone__input"  style={{width:"100%",height:"100%"}}>
                    <input {...getInputProps()} name={name} />
                    {files.length === 0 ? (
                      <div className="dropzone__drop-here">
                        <UploadIcon style={{marginTop:-2}}/> Click to Upload
                      </div>
                    ) : null}
                  </div>
                </Tooltip>
              )}
            </Dropzone>
            {files.length > 0 && (
              <aside className="dropzone__img">
                <img src={files[0].preview} alt="drop-img" style={{padding:0}} />
                <button
                  className="dropzone__img-delete"
                  type="button"
                  onClick={(e) => this.removeFile(0, e)}
                >
                  Remove
                </button>
              </aside>
            )}
          </>
        )}
      </div>
      </div>
    );
  }
}

const renderDropZoneField = (props) => {
  const {
    name, // Name is now correctly passed as a top-level prop
    customHeight,
    SnapShotDropZoneHeight,
    SnapShotDropLoader,
    defaultImage,
    callback,
    input,
    label
  } = props;

  return (
    <DropZoneField
      name={name}
      customHeight={customHeight}
      SnapShotDropZoneHeight={SnapShotDropZoneHeight}
      SnapShotDropLoader={SnapShotDropLoader}
      defaultImage={defaultImage}
      callback={callback}
      {...input} // Pass input prop
      label={label}
    />
  );
};

renderDropZoneField.propTypes = {
  name: PropTypes.string.isRequired, // Top-level prop for name
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  SnapShotDropZoneHeight: PropTypes.bool,
  SnapShotDropLoader: PropTypes.bool,
  customHeight: PropTypes.bool,
  defaultImage: PropTypes.string, // Prop for default image
  callback: PropTypes.func, // Prop for callback function
  label: PropTypes.string,
};

renderDropZoneField.defaultProps = {
  customHeight: false,
  defaultImage: "", // Default empty string for defaultImage
  callback: null, // Default null for callback
  input: {}, // Default empty object for input
};

export default renderDropZoneField;
